/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleGroupOptionState from './state/AccountTitleGroupOptionState'
import AccountTitleGroupEvent from '../../event/AccountTitileGroupEvent'

class AccountTitleGroupOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccountTitleGroupEvent.fetchAll:
        const groups = payload.groups.map(group => {
          return new AccountTitleGroupOptionState().mergeModel(group)
        })
        return List(groups)
      default:
        return state
    }
  }
}

export default new AccountTitleGroupOptionsStore()
